import React, { memo } from 'react';

import { log } from '../../services/utils';

import { useUIState } from '../../contexts/UIContext';

import UiLoader from '../Loaders/UiLoader';

import styles from './header.module.css';

const InfoBar = () => {
	const {
		infobar,
		infobarLoader
	} = useUIState();

	return (
		<div className={ `${ styles.infoBar } no-print` }>
			{ log( '- infoBar' ) }
			{ infobarLoader
				? <UiLoader message={ infobarLoader } />
				: <span className="no-print" >{ infobar }&nbsp;</span>
			}
		</div>
	);
};

export default memo( InfoBar );
